/** @jsxImportSource preact */
import type { ComponentChildren } from "preact";

import type { WidgetTokens } from "../theme";
import { Button } from "./base-ui.mjs";
import { formVars } from "./form-styles";

export interface FormButtonProps {
  tokens: WidgetTokens;
  /** primary 墨黑实心的主答案（每张卡只放一个）；secondary 白底胶囊带轻阴影；ghost 无底文字（重发、联系店铺这类）。 */
  variant?: "primary" | "secondary" | "ghost";
  /** 撑满一行。 */
  fullWidth?: boolean;
  disabled?: boolean;
  type?: "button" | "submit";
  /** 给了链接就渲染成 a，新页面打开；订单卡的 Track shipment、View order 用。 */
  href?: string;
  /** 紧凑：32px 高、12px 字，放在卡片里的次要操作用。 */
  compact?: boolean;
  onClick?: () => void;
  children?: ComponentChildren;
}

/**
 * 表单按钮，底层是 Base UI 的 Button。禁用时仍可聚焦（focusableWhenDisabled），
 * 读屏读得到 “Resend code in 0:30” 这类倒计时按钮。
 */
export function FormButton({
  tokens: t,
  variant = "primary",
  fullWidth = false,
  disabled = false,
  type = "button",
  href,
  compact = false,
  onClick,
  children,
}: FormButtonProps) {
  if (href !== undefined) {
    return (
      <a
        class="gn-btn"
        data-compact={compact ? "" : undefined}
        data-full={fullWidth ? "" : undefined}
        data-variant={variant}
        href={href}
        rel="noopener noreferrer"
        style={formVars(t)}
        target="_blank"
      >
        {children}
      </a>
    );
  }
  return (
    <Button
      className="gn-btn"
      data-compact={compact ? "" : undefined}
      data-disabled={disabled ? "" : undefined}
      data-full={fullWidth ? "" : undefined}
      data-variant={variant}
      disabled={disabled}
      focusableWhenDisabled
      onClick={onClick}
      style={formVars(t)}
      type={type}
    >
      {children}
    </Button>
  );
}
